// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"47247a6a04b1efbe9b0b","731":"6a239b70475c3194524b","843":"1324fb3a90350fe7a780","883":"04e5cfc69beca9218674"}[chunkId] + ".js";
};